<template>
    <div class="bg-box rounded shadow-md">
        <div class="flex flex-col justify-between h-full">
            <div class="py-5 px-4 relative flex items-center justify-center site-title-bar">
                <div class="text-xl text-center text-white font-bold">{{ title }}</div>

                <div class="absolute right-4">
                    <InfoIcon :identifier="`waste-chart-totalestimatedwaste`" />
                </div>
            </div>
            <div class="relative h-full flex flex-col items-center justify-between">
                <fusioncharts
                    type="angulargauge"
                    width="99%"
                    :height="height"
                    :dataSource="dataSource">
                </fusioncharts>
                <div class="relative my-6 text-xl text-white text-center font-bold">
                    <span>Currently</span>
                    <span class="p-2 font-bold mx-1 rounded" :class="estimatedWasteColor">
                        <span v-text="estimatedWastePercentage" class="text-white"></span>
                    </span>
                    <span class="inline-flex items-center justify-center gap-2">
                        Total Estimated Waste
                        <InfoIcon identifier="waste-chart-%totalestimatedwaste" />
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },

            height: {
                type: String,
                default: "300"
            },

            estimatedWaste: {
                type: Number,
                required: true,
            },
        },

        data () {
            return {

            }
        },

        computed: {
            dataSource() {
                return {
                    chart: {
                        bgColor: "#316DA0",
                        caption: "",
                        lowerLimit: "0",
                        upperLimit: "100",
                        showValue: "0",
                        numberSuffix: "%",
                        theme: "fusion",
                        showToolTip: "0",
                        majorTMColor: "#ffffff",
                        labelFontColor: "#ffffff",
                        pivotRadius: "10",
                        pivotFillMix: "{CCCCCC},{EEEEEE}",
                        pivotFillRatio: "50,50",
                        gaugeFillMix: "{light-10},{light-30},{light-20},{dark-5},{color},{light-30},{light-20},{dark-10}",
                        gaugeFillRatio: "",
                    },
                    colorRange: {
                        color: [
                            {
                                minValue: 0,
                                maxValue: 20,
                                code: "#62B58F"
                            },
                            {
                                minValue: 20,
                                maxValue: 40,
                                code: "#FFC533"
                            },
                            {
                                minValue: 40,
                                maxValue: 100,
                                code: "#F2726F"
                            }
                        ]
                    },
                    dials: {
                        dial: [
                            {
                                value: this.estimatedWaste,
                                borderAlpha: "100",
                                rearExtension: "15",
                                borderColor: "#B8C2CC",
                                borderThickness: "1",
                                bgColor: "#F1F1F1",
                                topWidth: "1",
                                baseWidth: "6"
                            }
                        ]
                    },
                }
            },

            estimatedWastePercentage() {
                return Math.abs(this.estimatedWaste) + "%";
            },

            estimatedWasteColor() {
                return this.estimatedWaste > 40 ? "bg-red-600" : (this.estimatedWaste <= 20 ? "bg-green-400" : "bg-yellow-300");
            }
        }
    }
</script>